var _path, _path2, _path3, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcIngresosEgresos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20H5C4.46957 20 3.96086 19.7893 3.58579 19.4142C3.21071 19.0391 3 18.5304 3 18V9C3 8.46957 3.21071 7.96086 3.58579 7.58579C3.96086 7.21071 4.46957 7 5 7H19C19.5304 7 20.0391 7.21071 20.4142 7.58579C20.7893 7.96086 21 8.46957 21 9V18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0391 19.7893 19.5304 20 19 20Z",
    stroke: "#01295F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3318 3.6321L10.3318 2.39659C10.3318 2.04775 10.4703 1.7132 10.717 1.46654C10.9637 1.21987 11.2982 1.0813 11.6471 1.0813L17.5659 1.0813C17.9147 1.0813 18.2493 1.21987 18.4959 1.46654C18.7426 1.7132 18.8812 2.04776 18.8812 2.39659L18.8812 7.00012",
    stroke: "#01295F",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21771 6.96638L6.21771 4.97789C6.21771 4.62905 6.35628 4.2945 6.60295 4.04784C6.84961 3.80117 7.18416 3.6626 7.533 3.6626L13.4518 3.6626C13.8007 3.6626 14.1352 3.80117 14.3819 4.04784C14.6285 4.2945 14.7671 4.62905 14.7671 4.97789L14.7671 6.96638",
    stroke: "#01295F",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.49242,
    y1: 16.2712,
    x2: 9.49242,
    y2: 13.3379,
    stroke: "#01295F",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.9707,
    y1: 16.2712,
    x2: 11.9707,
    y2: 12,
    stroke: "#01295F",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.5717,
    y1: 16.2712,
    x2: 14.5717,
    y2: 10.2207,
    stroke: "#01295F",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIngresosEgresos);
export default __webpack_public_path__ + "static/media/ic_ingresos_egresos.28530f75063b7734001eb058686b48d2.svg";
export { ForwardRef as ReactComponent };